var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMainKhelCoach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 382.01 130.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #231f20;\n      }\n\n      .cls-2 {\n        fill: #00adee;\n      }\n\n      .cls-3 {\n        fill: #e21f26;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M156.79,12.34c-3.07-4.04-8.76-4.89-12.7-1.89-3.94,3-4.65,8.7-1.58,12.75l14.29-10.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.89 64.59 186.19 46.32 178 64.59 209.89 64.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M208.49,22.12s-.03.03-.04.04l-17.09,13.06s-.05.02-.07,0l-8.46-6.66s-.02-.04,0-.06l17.09-13.06s.01,0,.04-.03l-11.87-9.31-4.25-3.33c-3.11-1.86-7.81-3.43-11.18-2.51-.02,0-17.19,13.1-17.19,13.1l-6.35,4.82s7.5-3.04,13.53.89l23.14,18.07,41.17,32.31s.05.01.07,0l21.12-16.15s.02-.04,0-.06l-39.67-31.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M140.01,63.28c-2.41-2.41-4.1-5.27-5.1-8.3,3.45-.07,6.93,1.2,9.56,3.83,2.63,2.63,3.9,6.11,3.83,9.56-3.03-1-5.89-2.69-8.3-5.1ZM165.44,37.85c2.62,2.62,6.08,3.89,9.52,3.83-1-3.02-2.68-5.86-5.09-8.26-2.4-2.4-5.25-4.08-8.26-5.09-.06,3.44,1.21,6.9,3.83,9.52ZM175.88,45.78c-4.8.32-9.71-1.34-13.37-5-3.66-3.66-5.32-8.57-5-13.37-6.22-.76-12.72,1.23-17.5,6.01-4.77,4.77-6.76,11.25-6.01,17.47,4.81-.33,9.74,1.33,13.41,5,3.67,3.67,5.33,8.6,5,13.41,6.21.75,12.7-1.25,17.47-6.01,4.78-4.78,6.77-11.27,6.01-17.5Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "116.82 86.62 89.94 86.62 87.95 94.59 110.62 94.59 116.82 86.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.07 121.55 81.21 121.55 79.22 129.52 101.87 129.52 108.07 121.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.18 86.62 69.89 103.78 51.32 103.78 55.61 86.64 44.94 95.25 36.37 129.52 44.89 129.52 49.31 111.81 67.88 111.81 63.45 129.52 71.97 129.52 82.7 86.62 74.18 86.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.63 103.76 101.64 103.72 85.67 103.72 83.8 111.2 95.85 111.2 101.63 103.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.33,129.52l-14.58-14.92-.61.45-3.62,14.46H0l10.73-42.9h8.52l-2.11,8.46c-1.76,7.05-2.53,9.62-2.47,9.62h.06c.06,0,2.73-2.33,7.71-6.31l15.81-11.77h9.38l-27.82,22.34,17.65,20.55h-10.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.64 121.55 121.78 121.55 130.52 86.62 122 86.62 111.27 129.52 136.45 129.52 142.64 121.55"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "350.63 103.78 354.91 86.61 346.38 86.61 335.69 129.54 344.21 129.54 348.63 111.81 350.63 103.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "373.49 86.61 369.21 103.78 357.79 103.78 351.51 111.81 367.21 111.81 362.79 129.54 371.32 129.54 382.01 86.61 373.49 86.61"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M280.83,86.61h-8.03l-28.36,42.93h9.2l5.24-8.22,4.82-7.54,6.94-10.85c1.52-2.39,3.51-5.95,3.57-5.95h.06c.06,0,.28,3.56.6,5.95l1.53,10.85h-8.11l-5.89,7.54h15.06l1.14,8.22h9.2l-6.96-42.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M232.69,85.75c12.33,0,19.98,9.38,16.76,22.32-3.22,12.94-15.56,22.32-27.89,22.32s-19.92-9.38-16.7-22.32,15.5-22.32,27.82-22.32ZM223.65,121.99c7.91,0,14.85-5.7,16.9-13.92,2.06-8.28-2.05-13.92-9.96-13.92s-14.77,5.64-16.84,13.92c-2.05,8.22,2.05,13.92,9.9,13.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M178.65,121.87c-7.67,0-12.02-5.4-9.93-13.8,2.03-8.16,8.8-13.92,16.84-13.92,4.2,0,9.51.21,12.39,7.19l5.33-6.84c-2.71-5.38-8.29-8.76-15.63-8.76-12.33,0-24.6,9.38-27.82,22.32-3.22,12.94,4.37,22.32,16.7,22.32,9.01,0,17.86-4.97,23.31-12.57l-8.02-2.27c-3.08,3.74-8.26,6.32-13.16,6.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M311.89,121.87c-7.67,0-12.02-5.4-9.93-13.8,2.03-8.16,8.8-13.92,16.84-13.92,4.21,0,9.54.21,12.42,7.25l5.34-6.84c-2.7-5.41-8.29-8.81-15.66-8.81-12.33,0-24.6,9.38-27.82,22.32s4.37,22.32,16.7,22.32c9.01,0,17.86-4.97,23.31-12.57l-8.02-2.27c-3.08,3.74-8.26,6.32-13.16,6.32Z"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainKhelCoach);
export default __webpack_public_path__ + "static/media/MainKhelCoach.6ddeb21318eb0ddef3d390cb738ddb60.svg";
export { ForwardRef as ReactComponent };